import { render, staticRenderFns } from "./file-upload-new.vue?vue&type=template&id=34284db3&scoped=true"
import script from "./file-upload-new.vue?vue&type=script&lang=js"
export * from "./file-upload-new.vue?vue&type=script&lang=js"
import style0 from "./file-upload-new.vue?vue&type=style&index=0&id=34284db3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34284db3",
  null
  
)

export default component.exports